import { render, staticRenderFns } from "./packaging.vue?vue&type=template&id=e140fed8&scoped=true&"
import script from "./packaging.vue?vue&type=script&lang=js&"
export * from "./packaging.vue?vue&type=script&lang=js&"
import style0 from "./packaging.vue?vue&type=style&index=0&id=e140fed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e140fed8",
  null
  
)

component.options.__file = "packaging.vue"
export default component.exports